import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import DashboardLayout from "@/components/DashboardLayout";
import WeeklyPlan from "@/pages/WeeklyPlan";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminSubjects from "@/pages/admin/AdminSubjects";
import AdminPlanEditor from "@/pages/admin/AdminPlanEditor";
import AdminStudyProgram from "@/pages/admin/AdminStudyProgram";
import AdminProgramArchive from "@/pages/admin/AdminProgramArchive";
import CoachStudents from "@/pages/CoachStudents";
import StudyProgram from "@/pages/StudyProgram";
import DailyQuestions from "@/pages/DailyQuestions";
import Exams from "@/pages/Exams";
import OzetEzber from "@/pages/OzetEzber";
import MonthlyEval from "@/pages/MonthlyEval";
import AdminBulkEval from "@/pages/admin/AdminBulkEval";
import AdminDataEntry from "@/pages/admin/AdminDataEntry";
import SinavTakvimi from "@/pages/SinavTakvimi";
import KonuTakibi from "@/pages/KonuTakibi";
import MatematikKampi from "@/pages/MatematikKampi";
import OptikSinav from "@/pages/OptikSinav";
import ReadingBooks from "@/pages/ReadingBooks";
import SinavTakip from "@/pages/SinavTakip";
import DenemeKarti from "@/pages/DenemeKarti";
import KaynakKutuphanesi from "@/pages/KaynakKutuphanesi";
import Overview from "@/pages/Overview";
import KarnePaneli from "@/pages/KarnePaneli";

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF8F5]">
      <div className="text-indigo-600 font-display text-2xl animate-pulse">ZOR NEW GENERATION ACADEMY…</div>
    </div>
  );
}

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function Index() {
  const { user } = useAuth();
  if (user?.role === "admin") return <Navigate to="/admin/kullanicilar" replace />;
  if (user?.role === "koc") return <Navigate to="/koc" replace />;
  return <Navigate to="/genel-bakis" replace />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <Protected>
            <DashboardLayout />
          </Protected>
        }
      >
        <Route index element={<Index />} />
        <Route path="program" element={<WeeklyPlan />} />
        <Route path="calisma-programi" element={<StudyProgram />} />
        <Route path="gunluk-soru" element={<DailyQuestions />} />
        <Route path="sinav-takip" element={<SinavTakip />} />
        <Route path="deneme-karti" element={<DenemeKarti />} />
        <Route path="kaynak-kutuphanesi" element={<KaynakKutuphanesi />} />
        <Route path="denemeler" element={<Exams />} />
        <Route path="sinav-takvimi" element={<SinavTakvimi />} />
        <Route path="konu-takibi" element={<KonuTakibi />} />
        <Route path="matematik-kampi" element={<MatematikKampi />} />
        <Route path="optik-sinav" element={<OptikSinav />} />
        <Route path="karne-paneli" element={<KarnePaneli />} />
        <Route path="ozet-ezber" element={<OzetEzber />} />
        <Route path="genel-bakis" element={<Overview />} />
        <Route path="aylik-degerlendirme" element={<MonthlyEval />} />
        <Route path="okuma-kitaplari" element={<ReadingBooks />} />
        <Route path="admin/toplu-degerlendirme" element={<AdminBulkEval />} />
        <Route path="koc" element={<CoachStudents />} />
        <Route path="admin/veri-girisi" element={<AdminDataEntry />} />
        <Route path="admin/ogrenci-panelleri" element={<CoachStudents />} />
        <Route path="admin/kullanicilar" element={<AdminUsers />} />
        <Route path="admin/dersler" element={<AdminSubjects />} />
        <Route path="admin/plan" element={<AdminPlanEditor />} />
        <Route path="admin/calisma-programi" element={<AdminStudyProgram />} />
        <Route path="admin/program-arsivi" element={<AdminProgramArchive />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
